export function stripQuerystringFromPath(url: string) {
  return url.split('?')[0];
}
